import React from 'react';
import { SecureApp } from 'core.ui-module_site-security';
import PageLoader from './components/PageLoader';
import { siteJson } from '../json/site';
import ContactUs from './layout/ContactUs';
import Welcome from './layout/Welcome';
import Footer from './layout/Footer';
import logo from '../images/logo/ms_researchinstitute_h_rev.png';

// Logo for navy theme, also navy theme colors defined in _colors.scss
// import logo from 'core.ui-module_site-styling/lib/images/logos/site-logo-reverse.svg';

const App = () => {
  return (
    <div className="site">
      <SecureApp
        logo={logo}
        logoWidth={225}
        logoHeight={82}
        loader={PageLoader}
        site={siteJson}
        contactUs={<ContactUs />}
        welcome={<Welcome />}
        footer={<Footer />}
        logoutSuccessPath="/home.html"
      />
    </div>
  );
};

export default App;
